<template>
   <footer>
      <div class="container">
        <div class="row" :style="currentLanguage !== 'ru_RU'? 'direction: rtl' : 'ltr'">
          <div class="col-sm-6 col-md-4">
            <div class="wow fadeInDown" data-wow-delay="0.1s">
              <div class="widget">
                <h5>{{sourceFooter.about}}</h5>
                <p>
                  {{sourceFooter.about_text}}
                </p>
              </div>
            </div>
            <div class="wow fadeInDown" data-wow-delay="0.1s">
              <div class="widget">
                <h5>{{sourceFooter.info}}</h5>
                <ul :class="currentLanguage !== 'ru_RU'? 'hebrew-ul':'russian-ul'">
                  <li v-for="item in menus" v-bind:key="item._id">
                    <router-link class="nav-link" :to="item.item_link">
                      {{item.title}}
                    </router-link>
                  </li> 
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="wow fadeInDown" data-wow-delay="0.1s">
              <div class="widget">
                <h5>{{sourceFooter.center}}</h5>
                <p>
                  {{sourceFooter.center_text}}
                </p>
                <ul :class="currentLanguage !== 'ru_RU'? 'hebrew-ul':'russian-ul'">
                  <li class="d-flex">
                    <span class="fa-stack fa-lg">
                      <i class="fa fa-circle fa-stack-2x"></i>
                      <i :class="currentLanguage === 'ru_RU'? 'fa fa-calendar-o fa-stack-1x fa-inverse fa-inverse-footer' : 'fa fa-calendar-o fa-stack-1x fa-inverse'"></i>
                    </span>
                    <div :class="currentLanguage === 'ru_RU'? 'workdays-container-rus':'workdays-container-heb'">
                       {{sourceFooter.workdays + ': 8:00 - 20:00'}} 
                       {{sourceFooter.workdays1 + ': 8:00 - 16:00'}} 
                    </div>                   
                  </li>
                  <li>
                    <span class="fa-stack fa-lg">
									<i class="fa fa-circle fa-stack-2x"></i>
									<i class="fa fa-phone fa-stack-1x fa-inverse"></i>
								</span>
                <span>03-6138935, </span>
                <span>050-8691442</span> 
                  </li>
                  <li>
                    <span class="fa-stack fa-lg">
									<i class="fa fa-circle fa-stack-2x"></i>
									<i class="fa fa-envelope-o fa-stack-1x fa-inverse"></i>
								</span> {{email}}
                  </li>

                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-4">
            <div class="wow fadeInDown" data-wow-delay="0.1s">
              <div class="widget">
                <h5>{{sourceFooter.location_title}}</h5>
                <p>{{sourceFooter.location}}</p>
              </div>
            </div>
            <div class="wow fadeInDown" data-wow-delay="0.1s">
              <div class="widget">
                <h5>{{sourceFooter.follow}}</h5>
                <ul :class="currentLanguage !== 'ru_RU'? 'company-social hebrew-ul':'company-social'">
                  <li class="social-facebook"><a href="https://www.facebook.com/Natalileech/" target="_blank"><i class="fa fa-facebook"></i></a></li>
                  <li class="social-instagram"><a href="https://www.instagram.com/n.k.chinese.medicine/" target="_blank"><i class="fa fa-instagram"></i></a></li>                 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-footer">
        <div class="container">
          <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="wow fadeInLeft" data-wow-delay="0.1s">
                <div class="text-left">
                  <p>&copy;Copyright - GIRUDO</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 col-lg-6">
              <div class="wow fadeInRight" data-wow-delay="0.1s">
                <div class="text-right">
                  <div class="credits" style="display: none;">
                    <!--
                      All the links in the footer should remain intact. 
                      You can delete the links only if you purchased the pro version.
                      Licensing information: https://bootstrapmade.com/license/
                      Purchase the pro version with working PHP/AJAX contact form: https://bootstrapmade.com/buy/?theme=Medicio
                    -->
                    Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
  import { InitSource } from '../sources/language_provider'
  import { getDataFromServer } from '../utils/DataProvider'
  export default {    
    data: () => {
      return{        
        sourceFooter: {about: "", about_text: "", center: "", center_text: "", location: "", info: "", follow: "", workdays: "", workdays1: "" },          
        currentLanguage: '',
        email: '',
        menus: [],
      }     
    },
    methods:{   
      getDataByLanguage(){
        console.log("getDataByLanguage get menu by lang: ", this.$store.getters.CURRENT_LANGUAGE)
        getDataFromServer('get_menu_by_lang_id', {id: 'main_menu', language: this.$store.getters.CURRENT_LANGUAGE})
        .then(obj => { 
          if(obj.data.success === true){ 
            console.log("getDataByLanguage menu by lang: ", obj.data.data);            
            this.menus = obj.data.data.menu_items
            
            InitSource(this.$store.getters.CURRENT_LANGUAGE, this.$store, () => {
              this.sourceFooter = this.$store.getters.SOURCE_JSON.footer;
              this.sourceFooter.workdays = this.$store.getters.SOURCE_JSON.general.workdays
              this.sourceFooter.workdays1 = this.$store.getters.SOURCE_JSON.general.workdays1             
            });
            this.currentLanguage = this.$store.getters.CURRENT_LANGUAGE
          }
          else{
            this.flash('getDataByLanguage get menu error: ' + obj.data.text , 'error', {timeout: 5000})
          }          
        })
        .catch(err => { 
          this.flash('getDataByLanguage get menu error: ' + err , 'error', {timeout: 5000})
        })
      }, 

      getSiteConfiguration(){
        getDataFromServer('get_homepage_data', null)
        .then(obj => {

          if(this.$store.getters.CURRENT_LANGUAGE === ''){
            this.currentLanguage = obj.data.config.data.language
          }else{
            this.currentLanguage = this.$store.getters.CURRENT_LANGUAGE
          }
          
          let arrMenus = obj.data.menus.data;
          this.menus = arrMenus.filter(m => m.menu_id === 'main_menu')[0].menu_items
          this.email = obj.data.config.data.contact_email
          console.log("main menu: ", this.menus)
          console.log("init header language ***************** ")
          InitSource(this.currentLanguage, this.$store, () => {
            this.sourceFooter = this.$store.getters.SOURCE_JSON.footer;
            this.sourceFooter.workdays = this.$store.getters.SOURCE_JSON.general.workdays
            this.sourceFooter.workdays1 = this.$store.getters.SOURCE_JSON.general.workdays1
          });
          this.currentLanguage = obj.data.config.data.language
        })
        .catch(err => { }) 
      }
    },  

    created(){     
      //get site data
      this.getSiteConfiguration() 
      
      this.$store.subscribe((mutation, state) => {
          if(mutation.type === 'SET_CURRENT_LANGUAGE'){
             console.log("created footer subscribe SET_CURRENT_LANGUAGE")           
             this.getDataByLanguage()           
          }
      })      
    }
  }
</script>

<style scoped>
    .hebrew-ul{
      float: right;
      padding-inline-start: 0;
    }

    .russian-ul{
      padding-inline-start:0;
    }

    .workdays-container-rus{
      margin-top: -5px;
      margin-left: 10px;
    }

    .workdays-container-heb{
      margin-top: 9px;      
    }

    .fa-inverse-footer{
      margin-left: 3px !important;
    }

</style>
